import { useError } from 'react-use';

import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchDemographicAudienceInsightSettings } from 'api/queries/customInsight';
import { DemographicSettings } from 'modules/domains/segmentation';

type FetchDemographicAudienceInsightSettings = {
  settings: DemographicSettings[];
  maxDemographicInsightSettingsForProject: number;
  success: boolean;
};

type CustomInsightsResponse = {
  fetchDemographicInsightSettings: FetchDemographicAudienceInsightSettings;
};

export const useCustomDemographicInsightsQuery = () => {
  const dispatchError = useError();
  const { data, isLoading, error, refetch } = useGraphql<CustomInsightsResponse>(
    fetchDemographicAudienceInsightSettings,
    { onError: dispatchError },
  );

  return {
    data: data?.fetchDemographicInsightSettings,
    isLoading,
    isError: !!error || !data?.fetchDemographicInsightSettings.success,
    isSuccess: !isLoading && !!data?.fetchDemographicInsightSettings.success,
    refetch,
  };
};
